
jQuery(function () {
    if($('#zipcode').length) {
        /*
         * 郵便番号から住所自動入力
         */
        $('#zipcode').jpostal({
            click: '#auto-load-address',
            postcode: [
                '#zipcode'
            ],
            address: {
                '#state_id': '%3',
                '#addr': '%4%5'
            }
        });
        $('input[name="zipcode"], .address-number input').on("keypress input", function(){
            let str = $(this).val();
            $(this).val(str.replace(/[^0-9\-]/g, ""));
          });
    }
});
